import Crud from '../views/PerfilUsuario/Crud'
import Entity from '../views/PerfilUsuario/Add'

let routes = {
    path: '/perfil_usuarios',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/perfil_usuarios/add',
            name: 'NewUser',
            component: Entity,
            meta: {                
                perfil_id: ['1']
            },
        },
        {
            path: '/perfil_usuarios/edit/:id?',
            name: 'EditUser',
            component: Entity,
            meta: {                
                perfil_id: ['1']
            },
        },
        {
            path: '/perfil_usuarios',
            name: 'list-perfil-usuario',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Perfis de Usuários',
                breadcrumb: [
                    {
                        text: 'Perfis de Usuários',
                        active: true,
                    },
                ],  
                perfil_id: ['1']
            },
        },
    ]
};


export default routes
